<template>
  <div>
    <router-link v-if='user.username !== "anonymous"' class="h-8 flex items-center justify-start " :class='classes' :to='{name:"userposts",params:{username:user.username}}'>
      <img v-if='user.username === "anonymous"' src="/img/PBC_Icon_LatestQuestions.png" alt="" class="object-contain w-4 mr-1">
      <img v-else src="/img/PBC_Meme.svg" alt="" class="object-contain w-4 mr-1">
      <p :class="truncate ? 'truncate' : ''">{{user.username}}</p>
    </router-link>
    <div v-else class="h-8 flex items-center justify-start " :class='classes'>
      <img v-if='user.username === "anonymous"' src="/img/PBC_Icon_LatestQuestions.png" alt="" class="object-contain w-4 mr-1">
      <img v-else src="/img/PBC_Meme.svg" alt="" class="object-contain w-4 mr-1">
      <p :class="truncate ? 'truncate' : ''">{{user.username}}</p>
    </div>
  </div>
</template>
<script>
export default {
  props:{
    user:{
      type:Object,
      default() {
        return {
          username: 'anonymous',
          avatarImage: 'placeholder.png'
        }
      }
    },
    truncate: {
      type: Boolean,
      default: false
    }
  },
  methods:{
    gotoUser() {
      if (this.user.username === 'anonymous') {
        return;
      }
      this.$router.push({
        name:'userposts',
        params:{
          username:this.user.username
        }
      });
    }
  },
  computed:{
    classes() {
      if (this.user.username !== 'anonymous') {
        return 'cursor-pointer text-sm font-semibold'
      } else {
        return 'text-xs font-thin';
      }
    }
  }
}
</script>
